import { Store } from 'pullstate';
export const default_booking_form_store = {
  loading: false,
  status_messages: {},
  create_account: false,
  login_modal: false,
  cgu_modal: false,
  cgu_employee_modal: false,
  google_redirecting: false,
  newsletter_subscription: false,
  cgu_accepted: false,
  is_customer: false,
  services: [],
  showPassword: false,
  reservation_source: 'front',
  in_newsletter: false,
  token_error: false
};
const BookingFormStore = new Store(default_booking_form_store);
export default BookingFormStore;
